<template>
    <HeartRecoveryModal v-if="modalStore.modals[ModalEnum.HEART_RECOVERY]" />
    <BybitDealRewardClaimedNotificationModal v-if="modalStore.modals[ModalEnum.BYBIT_DEAL_REWARD_CLAIMED]" />
    <BybitDealNotificationModal v-if="modalStore.modals[ModalEnum.BYBIT_DEAL_NOTIFICATION]" />
</template>

<script setup lang="ts">
    import { watch } from 'vue';
    import { useRouter } from 'vue-router';
    import { ModalEnum, useModalStore } from '@/js/store/quests/game/modules/ModalStore';
    import HeartRecoveryModal from '@/js/quests/dashboard/modals/notifications/HeartRecoveryModal.vue';
    import BybitDealNotificationModal from '@/js/quests/dashboard/modals/notifications/BybitDealNotificationModal.vue';
    import BybitDealRewardClaimedNotificationModal
        from '@/js/quests/dashboard/modals/notifications/BybitDealRewardClaimedNotificationModal.vue';
    import { useUserStore } from '@/js/store/quests/dashboard/UserStore';
    import { NotificationModalTypeEnum } from '@/js/quests/dashboard/types/enums';
    import { Notification } from '@/js/quests/dashboard/types/types';
    import { dashboardRoutesNames } from '@/js/quests/dashboard/constants/dashboardRoutesNames';

    const modalStore = useModalStore();
    const userStore = useUserStore();
    const router = useRouter();

    function openModalAndWaitForClose(notification: Notification) {
        return new Promise<void>((resolve) => {
            setTimeout(() => {
                let modalToToggle: ModalEnum | null = null;
                let modalToWatch: ModalEnum | null = null;

                switch (notification.type as NotificationModalTypeEnum) {
                case NotificationModalTypeEnum.RegistrationRewardReceived:
                    modalToToggle = ModalEnum.REGISTER_BONUS;
                    modalToWatch = ModalEnum.INTRODUCTION;
                    break;
                case NotificationModalTypeEnum.HeartRecovered:
                    modalToToggle = ModalEnum.HEART_RECOVERY;
                    modalToWatch = ModalEnum.HEART_RECOVERY;
                    break;
                case NotificationModalTypeEnum.QuestSeasonUserRewardClaim:
                    // Legacy modal removed; redirect user to leaderboard or provided URL
                    if (notification?.data?.url) {
                        window.location.href = notification.data.url;
                    } else {
                        router.push({ name: dashboardRoutesNames.LEADERBOARD_ROUTE_NAME });
                    }
                    resolve();

                    return;
                case NotificationModalTypeEnum.BybitDealRewardClaimed:
                    modalToToggle = ModalEnum.BYBIT_DEAL_REWARD_CLAIMED;
                    modalToWatch = ModalEnum.BYBIT_DEAL_REWARD_CLAIMED;
                    break;
                case NotificationModalTypeEnum.BybitDeal:
                    modalToToggle = ModalEnum.BYBIT_DEAL_NOTIFICATION;
                    modalToWatch = ModalEnum.BYBIT_DEAL_NOTIFICATION;
                    break;
                default:
                    resolve();

                    return;
                }

                modalStore.toggleModal(modalToToggle, true);
                const stopWatch = watch(() => modalStore.modals[modalToWatch], (newValue) => {
                    if (!newValue) {
                        stopWatch();
                        resolve();
                    }
                });
            }, 1000);
        });
    }

    watch(() => userStore.notifications, async (newNotifications) => {
        if (modalStore.skipNotifications) {
            return;
        }
        if (newNotifications !== null) {
            // eslint-disable-next-line no-restricted-syntax
            for (const notification of newNotifications) {
                // eslint-disable-next-line no-await-in-loop
                await openModalAndWaitForClose(notification);
            }
        }
    }, { immediate: true });
</script>
